<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { capFirstChar } from 'src/helpers/utilities';
	import { real_id } from 'src/helpers/interface_helpers';
	import { getAddonType, type AddonType } from 'src/helpers/addons/addon_support_helpers';
	//Stores
	import { rebooting_devices, updating_devices } from 'src/stores/device-runtime/process';
	import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Design system components
	import { Alert } from '@Shelly/shelly-design-system';
	//Components
	import AltFirmwareUpdating from './AltFirmwareUpdating.svelte';
	//Types
	import type { Device } from 'src/types/Device';
	import AddonSettings from './AddonSettings.svelte';

	$: statusStore = getDeviceStatus(id);
	export let device: Device;

	const id = real_id(device.id);

	let addonType: AddonType = '';
	let offlineDevice = false;

	$: updatingFW = $updating_devices[id];
	$: rebootingDevice = $rebooting_devices.indexOf(id) !== -1;
	$: offlineDevice = !$statusStore?.online;
	$: settingsStore = getDeviceSettings(id);
	$: addonType = $settingsStore ? getAddonType(device) : '';
</script>

{#if updatingFW}
	<AltFirmwareUpdating {updatingFW} />
{:else if rebootingDevice}
	<Alert
		type="info"
		class="mb-s"
		customIcon="fas fa-arrows-rotate text-primary"
		isHeadingBold
		heading={capFirstChar(
			$format('device_status_rebooting', {
				default: 'Device is rebooting',
			}),
		)}
	/>
{:else if offlineDevice}
	<Alert
		type="warning"
		class="mb-s"
		customIcon="fal fa-wifi-slash text-danger"
		isHeadingBold
		heading={capFirstChar(
			$format('device_status_no_connection', {
				default: 'Device is offline',
			}),
		)}
	/>
{:else}
	{#key addonType}
		<AddonSettings {device} {addonType} />
	{/key}
{/if}
